export function generateDynamicColorSchemeCSS(scheme: { [tint: string]: string }): string {
  const variables = Object.entries(scheme).map(([tint, hex]) => {
    return generateColorVariable(tint, hex)
  })
  return `:root {${variables.join(' ')}}`
}

function generateColorVariable(tint: string, hex: string) {
  return `${variableName(tint)}: ${hex};`
}

function variableName(tint: string): string {
  return `--color-brand-${tint}`
}
